import React, { useState } from 'react';

export default ({ maxHeight = 0, src, alt, onClick }) => {
  const [height, setHeight] = useState(maxHeight);
  const onImgLoad = ({ target: img }) => {
    setHeight(img.naturalHeight);
  };
  return (
    <img
      onClick={onClick}
      style={{
        maxHeight: maxHeight < height ? maxHeight : height,
        width: 'auto',
        maxWidth: '100%',
        aspectRatio: 'auto',
      }}
      onLoad={onImgLoad}
      src={src}
      alt={alt}
    />
  );
};
